module.exports = __webpack_public_path__ + "static/presidents-message-e49bc7b99ea725a3955892883505cb34.jpg";